"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouteParsers = createRouteParsers;
const validators_1 = require("../validators/index.js");
function createRouteParsers({ pageSlugs }) {
    function parseQuestionNumber(path) {
        const segments = path.split("/").filter(Boolean);
        const questionIndex = (() => {
            for (const slugs of Object.values(pageSlugs)) {
                const index = segments.indexOf(slugs.question);
                if (index !== -1)
                    return index;
            }
            return -1;
        })();
        if (questionIndex === -1) {
            throw new Error("Question segment not found in path");
        }
        const questionNumberString = segments[questionIndex + 1];
        if (!questionNumberString) {
            throw new Error("Missing question number in path");
        }
        if (segments[questionIndex + 2]) {
            throw new Error("Unexpected path segments after question number");
        }
        return (0, validators_1.validateQuestionNumber)(questionNumberString);
    }
    const parsedParams = {
        questionNumber: (path) => parseQuestionNumber(path),
    };
    return { parsedParams };
}
